<div class="icon-arrow-down-12 table-expand" id="table-expand" [class.disabled]="disabled"></div>
<ng-content></ng-content>
